import { syncOnlineMeetingsCloudSettingWithMailboxConfig } from '../actions/internalActions';
import { getStore } from '../store/store';
import shouldSyncOnlineMeetingsByDefault from '../utils/shouldSyncOnlineMeetingsByDefault';

/**
 * Gets the value for the enableOnlineMeetingsByDefault cloud setting
 */
export default function getEnableOnlineMeetingsByDefaultCloudSetting(): boolean | undefined {
    // Bug 84778: Remove online meetings setting sync between OCS and mailbox config when the migration is done
    // In case CalendarMailboxConfig wasn't initialized when we tried to sync the first time
    if (shouldSyncOnlineMeetingsByDefault()) {
        syncOnlineMeetingsCloudSettingWithMailboxConfig();
    }

    return getStore().enableOnlineMeetingsByDefault;
}
